import { CustomerModel } from '../shared/models/customer-model';
import { Component, OnInit, Input } from '@angular/core';
import { CustomerStatusEnum } from '@admin/customers/shared/models/customer-status.enum';

@Component({
  selector: 'hr-customer-details',
  templateUrl: './customer-details.component.html',
  styleUrls: ['./customer-details.component.less'],
  standalone: false,
})
export class CustomerDetailsComponent implements OnInit {
  @Input()
  public customer: CustomerModel;

  public customerStatusEnum: any = CustomerStatusEnum;

  constructor() {}

  ngOnInit() {}
}
